import { createSlice } from '@reduxjs/toolkit';
import {
  handleResetFilter,
  handleSetSelectedFilterIds,
  handleToggleCollapsed,
  handleSetSelectedContentBasedValues,
  handleChangeSortBy,
  handleSetSelectedFilterValue,
} from 'store/helpers/filterHelpers';
import { handleApplySettingsFilters } from './resourceHelpers';
import { twitterFiltersInitialState } from './initialState/twitterInitialState';

export { twitterFiltersInitialState as filtersInitialState };

export const twitterSearchResourceInitialState = {
  filters: twitterFiltersInitialState,
  sortBy: {
    selected: 'follower_count',
    order: 'desc',
  },
  selectedFilter: 'contentBasedFilter',
};
export const twitterSearchResourceSlice = createSlice({
  name: 'twitterSearchResourceSlice',
  initialState: twitterSearchResourceInitialState,
  reducers: {
    setSelectedFilterIds: (state, action) => {
      handleSetSelectedFilterIds(state, action);
    },
    setSelectedContentBasedValues: (state, action) => {
      handleSetSelectedContentBasedValues(state, action);
    },
    setSelectedFilterValue: (state, action) => {
      handleSetSelectedFilterValue(state, action, twitterFiltersInitialState);
    },
    changeSortBy: (state, action) => {
      handleChangeSortBy(state, action);
    },
    toggleCollapsed: (state, action) => {
      handleToggleCollapsed(state, action);
    },
    resetAllFilters: (state) => {
      state.filters = twitterFiltersInitialState;
    },
    resetFilter: (state, action) => {
      handleResetFilter(state, action, twitterFiltersInitialState);
    },
    applyWebsiteSettingsFilters: (state, action) => {
      handleApplySettingsFilters(state, action);
    },
    setSelectedFilter: (state, action) => {
      state.selectedFilter = action.payload;
    },
  },
});

export const {
  setSelectedFilterIds,
  toggleCollapsed,
  resetAllFilters,
  resetFilter,
  setSelectedContentBasedValues,
  setSelectedFilterValue,
  changeSortBy,
  applyWebsiteSettingsFilters,
  setSelectedFilter,
} = twitterSearchResourceSlice.actions;
